import { Injectable, OnInit } from '@angular/core';
import { Observable, Subject, delay, tap, timeout } from 'rxjs';
import { SectionStateStatus } from '../common/shared.enums';

@Injectable({
  providedIn: 'root',
})
export class LoadingService implements OnInit {
  // private fields
  private loadingStatus = new Subject<SectionStateStatus>();

  // public fields
  public loadingStatus$ = this.loadingStatus.asObservable();

  public loadingPopup: Subject<boolean> = new Subject();
  public loadingPopup$ = this.loadingPopup.pipe(
    delay(150),
    tap((res) => this.loadingPopup.asObservable())
  );

  public afterClosePopupObject: Object;

  constructor() { }
  ngOnInit(): void { }

  // actions
  public startLoading(loadingStatus: SectionStateStatus) {
    this.loadingStatus.next(loadingStatus);
  }

  public stopLoading() {
    this.loadingStatus.next(SectionStateStatus.HideLoading);
  }
}
